import { createFileRoute } from "@tanstack/react-router"
import { ManyChatComparisonPage } from "@/routes/comparison/manychat-vs-zapify-pro"

export const Route = createFileRoute("/$lang/comparison/manychat-vs-zapify-pro")({
  component: ManyChatComparisonPage,
})
